import { useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { usePostValidatePixQrCodeKeyMutation, usePostValidatePixQrCodeKeyV3Mutation } from '../../services/pixKeysApi';
export function usePostValidatePixQrCodeKey() {
    const { t } = useTranslation();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isBaasV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const [triggerV2] = usePostValidatePixQrCodeKeyMutation();
    const [triggerV3] = usePostValidatePixQrCodeKeyV3Mutation();
    const trigger = isBaasV2Enabled ? triggerV3 : triggerV2;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [qrCodePixKey, setQrCodePixKey] = useState();
    async function postValidateQrCodePixKey(key, rethrow) {
        setLoading(true);
        setError(undefined);
        setQrCodePixKey(undefined);
        try {
            const { data } = await trigger({ key });
            if (!data?.result) {
                throw new Error(t('can-not-get-pix-data-from-qr-code'));
            }
            else {
                setQrCodePixKey(data.result);
                return data.result;
            }
        }
        catch (err) {
            setError(t('can-not-get-pix-data-from-qr-code'));
            if (rethrow) {
                throw err;
            }
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        qrCodePixKey,
        setQrCodePixKey,
        postValidateQrCodePixKey,
    };
}
